<template>
  <div class="head">
    <div class="return">
      <a href="tel:02887507333" style="color:#fff">
        <van-icon name="phone" size="24" style="margin-lef" />
      </a>
    </div>
    <div class="title">
      <img
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/logo/white-logo.png"
        style="margin-top:2px;width: 100%;height: 37px;margin-top:6px"
      />
    </div>
    <div class="chat">
      <van-icon name="ellipsis" @click="showPopup" size="24" />
    </div>

    <van-popup v-model="show" position="bottom"  round>
      <div class="more-list2" style="border-bottom:#fff;">
        <div class="more-list-to">导航</div>
        <div class="more-list-menu">
          <div class="menu">
            <div class="menu-one">
              <div class="menu-img">
                <router-link to="/class">
                  <img src="../../icons/find.png" alt />
                </router-link>
              </div>
              <div class="menu-name">热门专业</div>
            </div>
            <div class="menu-one">
              <div class="menu-img">
                <router-link to="/school">
                  <img src="../../icons/school.png" alt />
                </router-link>
              </div>
              <div class="menu-name">学校简介</div>
            </div>
            <div class="menu-one">
              <div class="menu-img">
                <router-link to="/place">
                  <img src="../../icons/area.png" alt />
                </router-link>
              </div>
              <div class="menu-name">校园环境</div>
            </div>
            <div class="menu-one">
              <div class="menu-img">
                <router-link to="/works">
                  <img src="../../icons/students.png" alt />
                </router-link>
              </div>
              <div class="menu-name">教学作品</div>
            </div>
          </div>
        </div>
      </div>
      <div class="more-list2" >
        <div class="more-list-to"></div>
        <div class="more-list-menu">
          <div class="menu">
            <div class="menu-one">
              <div class="menu-img">
                <router-link to="/jobs">
                  <img src="../../icons/work.png" alt />
                </router-link>
              </div>
              <div class="menu-name">创就业服务</div>
            </div>
            <div class="menu-one">
              <div class="menu-img">
                <router-link to="/shop">
                  <img src="../../icons/teacher.png" alt />
                </router-link>
              </div>
              <div class="menu-name">我要开店</div>
            </div>
            <div class="menu-one">
              <div class="menu-img">
                <router-link to="/news">
                  <img src="../../icons/news.png" alt />
                </router-link>
              </div>
              <div class="menu-name">学校新闻</div>
            </div>
           <div class="menu-one">
              <div class="menu-img">
                <router-link to="/video/active/1">
                  <img src="../../icons/video.png" alt />
                </router-link>
              </div>
              <div class="menu-name">视频中心</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="more-list2" style="border-bottom:none;">
        <div class="more-list-to">站外分享:</div>
        <div class="more-list-menu">
          <div class="menu">
            <div class="menu-one">
              <div class="menu-img">
                <img src="../../icons/weixin.png" alt />
              </div>
              <div class="menu-name">微信</div>
            </div>
            <div class="menu-one">
              <div class="menu-img">
                <img src="../../icons/pyq.png" alt />
              </div>
              <div class="menu-name">朋友圈</div>
            </div>
            <div class="menu-one">
              <div class="menu-img">
                <img src="../../icons/qq.png" alt />
              </div>
              <div class="menu-name">QQ</div>
            </div>
            <div class="menu-one">
              <div class="menu-img">
                <img src="../../icons/weibo.png" alt />
              </div>
              <div class="menu-name">微博</div>
            </div>
          </div>
        </div>
      </div> -->
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    };
  },
  props: {
    title: {
      type: String,
      default: ""
    }
  },

  methods: {
    showPopup() {
      this.show = true;
    }
  },
  mounted() {
    window.scroll(0, 0);
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-popup--bottom.van-popup--round {
  background: #fff;
  margin-bottom: 50px;
}

.head {
  width: 100%;
  height: 50px;
  padding: 0 16px 0 16px;
  position: fixed;
  color: #fff;
  top: 0;
  background: #aa6b01;
  z-index: 999;
}
.return {
  width: 21%;
  float: left;
  line-height: 64px;
  height: 50px;
  text-align: left;
}
.title {
  width: 57%;
  float: left;
  line-height: 52px;
  font-size: 15px;
  height: 50px;
  text-align: center;
}
.chat {
  width: 21%;
  float: left;
  line-height: 64px;
  height: 50px;
  text-align: right;
  margin-right: 0;
}
.more-list2 {
  width: 100%;
  height: 70px;
  color: #080707;
  background: #fff;
  margin-top: 10px;
}
.more-list-to {
  width: 15%;
  height: 50px;
  line-height: 50px;
  float: left;
  margin-left: 20px;
  margin-right: 10px;
}

.menu-one {
  width: 50px;
  height: 60px;
  margin-right: 5%;
  float: left;
  text-align: center;
}
.menu-img {
  width: 40px;
  margin-left: auto;
  margin-right: auto;
  height: 40px;
}
.menu-img img {
  width: 100%;
  height: 100%;
}
.menu-name {
  width: 100%;
  margin-top: 3px;
  font-size: 12px;
}
</style>
